module.exports = __webpack_public_path__ + "static/zanchettaLogo-9d58fd120e297a8c1c4b16e0ff7231a4.svg";